import axios from "axios"
import { API_URL } from "./constants"
//pass new generated access token here
// const token = accessToken

//apply base url for axios
// const API_URL = ""

const axiosApi = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// axiosApi.defaults.headers.common["apikey"] = 

const checkAuth = (data, status) => {
  let d = data, s = status;
  if (typeof data === "string" && data.includes('<!DOCTYPE html>')) {
    localStorage.removeItem('authUser');
    d = [], s = '402';
  }
  return { data:d, status:s };
};

axiosApi.interceptors.response.use(
  response => response,
  error => {
    const {response: {status = ""} = {}} = error;
    if (status === 403) {
      localStorage.removeItem('authUser');
    }
    return Promise.reject(error)
  }
);

export function get(url, config = {}) {
  const { customHeader, ...options } = config;
  if (customHeader) {
    options.headers = { ...options.headers, ...customHeader };
  }
  return axiosApi.get(url, options).then(response => { 
    const {data , status} = response;
    // console.log("on api helper:", data);
    // console.log("status on api helper:", status);
    return checkAuth(data, status);
    ; 
  });
}

export function del(url, config = {}) {
  const { customHeader, ...options } = config;
  if (customHeader) {
    options.headers = { ...options.headers, ...customHeader };
  }
  return axiosApi.delete(url, options).then(response => { 
    const {data , status} = response;
    return checkAuth(data, status);
  });
}
const handleRequest = (method, url, data, config = {}) => {
  const { customHeader, ...options } = config;
  if (customHeader) {
    options.headers = { ...options.headers, ...customHeader };
  }
  return axiosApi[method](url, data, options).then(response => { 
    const {data , status} = response;
    return checkAuth(data, status);
  });
};


export const post = (url, data, config = {}) => handleRequest('post', url, data, config);
export const put = (url, data, config = {}) => handleRequest('put', url, data, config);
// export const del = (url, config = {}) => handleRequest('delete', url, null, config);
export const patch = (url, data, config = {}) => handleRequest('patch', url, data, config);